import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { type ComponentProps } from 'react';

type DeleteRuleDialogProps = Pick<
    ComponentProps<typeof WarningDialog>,
    'isOpen' | 'onPrimaryButtonClick' | 'onSecondaryButtonClick'
>;

export const DeleteRuleDialog = ({
    isOpen,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}: DeleteRuleDialogProps) => (
    <WarningDialog
        dialogTitle="Delete Rule"
        primaryButtonLabel="Yes, Delete"
        primaryButtonIntent={Button.Intent.DANGER}
        secondaryButtonLabel="No, Return To Form"
        isOpen={isOpen}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSecondaryButtonClick={onSecondaryButtonClick}
        dialogContent={
            <p>Are you sure you want to delete this rule? This is a permanent action.</p>
        }
    />
);
